import * as React from "react"
import styled from "styled-components"
import { View, Icon } from "../../components"
import ImageSelect from "../../components/ImageSelect"
import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import client from "../../user/authClient"

const UPDATE_PRODUCT_IMAGE = gql`
  mutation updateProduct($id: Int!, $image: String!) {
    updateProduct(input: { id: $id, patch: { image: $image } }) {
      product {
        id
        image {
          url
          thumb
        }
      }
    }
  }
`

const Container = styled(View)`
  position: absolute;
  left: 0;
  top: 0;
`

const ProductImageSelect = ({ id }) => {
  const [updateProduct] = useMutation(UPDATE_PRODUCT_IMAGE, { client })

  return (
    <Container pl={2} pt={3} onClick={(e) => e.preventDefault()}>
      <ImageSelect
        callback={(blob) =>
          updateProduct({
            variables: { image: blob.replace(/^data:.+;base64,/, ""), id },
          })
        }
        iconOnly
        size={32}
      />
    </Container>
  )
}

export default ProductImageSelect
